<ng-container *ngIf="showLogin">
  <h2 *ngIf="showTitle" translate="COMMON_UI.KEY_WORD.LOGIN"></h2>
  <shared-form-editor [config]="loginConfig"></shared-form-editor>
</ng-container>

<ng-container *ngIf="showRegister">
  <h2 *ngIf="showTitle" translate="COMMON_UI.KEY_WORD.REGISTER"></h2>
  <shared-form-editor [config]="registerConfig"></shared-form-editor>
</ng-container>
